import { useState } from "react";
import { Plus, X } from "lucide-react";

const FAQ = () => {
  const [openQuestion, setOpenQuestion] = useState(0); // First question open by default

  const faqs = [
    {
      id: 1,
      question: "Which financial tools are included in LeebAI?",
      answer:
        "LeebAI includes tools for tracking expenses, setting budgets, analyzing investments, forecasting future finances, and generating detailed reports—all in one place.",
    },
    {
      id: 2,
      question: "What can I do with LeebAI?",
      answer:
        "With LeebAI, you can engage in natural conversations, get instant answers to complex questions, generate creative content, analyze data, write code, search the web, create images, and much more. Our AI adapts to your specific needs and workflow.",
    },
    {
      id: 3,
      question: "What can I do with LeebAI?",
      answer:
        "LeebAI offers comprehensive AI capabilities including conversational assistance, content creation, data analysis, code generation, web research, image creation, and personalized recommendations tailored to your business needs.",
    },
    {
      id: 4,
      question: "Does LeebAI support personal finance management?",
      answer:
        "Yes, LeebAI provides intelligent financial insights and can help you track expenses, create budgets, analyze spending patterns, and make informed financial decisions through conversational AI assistance.",
    },
    {
      id: 5,
      question: "What makes LeebAI useful for finance tasks?",
      answer:
        "LeebAI combines advanced AI with financial expertise to provide real-time analysis, automated reporting, intelligent forecasting, and personalized financial advice, making complex financial tasks simple and accessible.",
    },
  ];

  const toggleQuestion = (questionId) => {
    setOpenQuestion(openQuestion === questionId ? null : questionId);
  };

  // This section displays FAQs and is targeted by header navigation
  return (
    <section className="py-20 bg-bg-70" id="faq">
      <div className="w-[90%] max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            <span className="text-fg-60">Frequently asked</span>
            <br />
            <span className="text-fg-40">questions</span>
          </h1>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-bg-70 rounded-2xl border border-bd-50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleQuestion(faq.id)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-bg-60 transition-colors"
              >
                <span className="text-fg-40 font-medium text-base md:text-lg pr-4">
                  {faq.question}
                </span>
                <div className="flex-shrink-0">
                  {openQuestion === faq.id ? (
                    <X size={20} className="text-fg-60" />
                  ) : (
                    <Plus size={20} className="text-fg-60" />
                  )}
                </div>
              </button>

              {openQuestion === faq.id && (
                <div className="px-6 pb-6">
                  <div className="pt-2 border-t border-bd-50">
                    <p className="text-fg-60 text-sm md:text-base leading-relaxed mt-4">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
